export const EMPTY_CUSTOM_RUN_NAMES = {};
